import React, { useState, useEffect } from 'react'
import { useStyles } from './HomeStudentPromotions_style'
import PromotionAPI from 'api/PromotionAPI'
import isEmpty from 'lodash.isempty'
import { Box, Container, Hidden } from '@material-ui/core'
import SectionSubTitle from 'components/SectionSubTitle/SectionSubTitle'
import Button from 'shared/components/Button/Button.jsx'
import { FormattedMessage } from 'react-intl'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import PromotionCard from 'cards/PromotionCard/PromotionCard'
import HorizontalCardsSlider from 'components/HorizontalCardsSlider/HorizontalCardsSlider'
import BannerWrapper from 'shared/wrappers/BannerWrapper/BannerWrapper'
import MotionIconFactory from 'icons/MotionIconFactory/MotionIconFactory'

const HomeStudentPromotions = () => {
    const classes = useStyles()
    const [promotions, setPromotions] = useState(null)

    useEffect(() => {
        const data = { amount: 8 }
        PromotionAPI.GetPromotions(data).then((response) => {
            setPromotions(response.data.promotions)
        })
    }, [])

    if (isEmpty(promotions)) return null

    return (
        <BannerWrapper>
            <Container maxWidth='lg' className={classes.promotionSection}>
                <Hidden smDown>
                    <Box className={classes.motionIconBox}>
                        <MotionIconFactory motionIcon='carrots'/>
                    </Box>
                    <Box className={classes.motionIconBoxBis}>
                        <MotionIconFactory motionIcon='pig-money' delay={500}/>
                    </Box>
                </Hidden>
                <SectionSubTitle
                    titleId='landing_home_student.promotions.title'
                    descriptionId='landing_home_student.promotions.description'
                />
                <Box className={classes.promotionBox}>
                    <HorizontalCardsSlider shift={300} wrappedArrows>
                        {promotions.map((promotion, index) => {
                            return (
                                <Box className={classes.promotionCardContainer} key={index}>
                                    <PromotionCard key={index} promotion={promotion}/>
                                </Box>
                            )
                        })}
                    </HorizontalCardsSlider>
                </Box>
                <Box className={classes.showMoreButtonBox}>
                    <RouteMapLink page='only-for-students'>
                        <Button className={classes.showMoreButton}>
                            <FormattedMessage id='item_index.show_more_button' />
                        </Button>
                    </RouteMapLink>
                </Box>
            </Container>
        </BannerWrapper>
    )
}

export default HomeStudentPromotions
